/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import isNil from 'lodash/isNil';
import moment from 'moment';

import { RECEIVED_CUSTOMER } from 'state/customer/CustomerActions';

export const customerInitialState = {
  fullName: null,
  serviceLevel: null,
  serviceType: null,
  isAdvicePlanningClient: false,
  isRetirementAdvisoryServiceClient: false,
  isAdvicePlanningOnboardingEngagementCompleted: false,
  ldapId: null,
  businessPartyId: null,
  birthDate: null,
  delegatedUserId: null,
  mailingAddress: {}
};

export const customerReducer = (state = {}, action) => {
  if (action.type === RECEIVED_CUSTOMER) {
    const { birthDate } = action.customer;
    const age = isNil(birthDate)
      ? 0
      : moment.utc().diff(moment.utc(birthDate), 'years');
    return {
      ...action.customer,
      age
    };
  }
  return state;
};
